var meaasgeAlert = function(meaasge) {
    var div = document.createElement('div');
    div.className = "message-alert";
    if(window.browserVersion.mobile){
        div.className = "message-alert-m";
    }
    document.body.appendChild(div);
    div.innerHTML = meaasge;
    var timer = setTimeout(function(){
        document.body.removeChild(div);
    },1000)
};
window.meaasgeAlert=meaasgeAlert;

export default meaasgeAlert;